module.exports = __WEBPACK_EXTERNAL_MODULE_82__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 82
// module chunks = 0